var _defs, _tspan, _tspan2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFontsize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    id: "svg287",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs291"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.84746,
    y: 108.47458,
    width: 880.81356,
    height: 685.55932,
    id: "rect305"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.84746,
    y: 108.47458,
    width: 880.81354,
    height: 685.55933,
    id: "rect305-1"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    id: "text303",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: 192,
      lineHeight: 1.25,
      fontFamily: "Arial",
      letterSpacing: 0,
      wordSpacing: 0,
      whiteSpace: "pre",
      shapeInside: "url(#rect305)",
      display: "inline"
    },
    transform: "matrix(4.5512777,0,0,5.1357474,-600.75911,-645.37132)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 138.84766,
    y: 281.41946,
    id: "tspan10706"
  }, "A"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    id: "text303-4",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: 192,
      lineHeight: 1.25,
      fontFamily: "Arial",
      letterSpacing: 0,
      wordSpacing: 0,
      whiteSpace: "pre",
      shapeInside: "url(#rect305-1)",
      display: "inline",
      overflow: "hidden",
      fill: "currentColor"
    },
    transform: "matrix(3.0990433,0,0,3.3169817,137.47798,-133.55693)"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 138.84766,
    y: 281.41946,
    id: "tspan10708"
  }, "A"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontsize);
export default __webpack_public_path__ + "static/media/fontsize.db7b0425980553239ae8582045cc97ab.svg";
export { ForwardRef as ReactComponent };